<template>
    <main id="mainCtrl">
        <div class="booking">
            <div class="promo__title">Запись пациентов на приём</div>

            <div class="alert alert-warning" v-if="clinic.moderationNeeded" style="margin-bottom: 10px;">
                Внимание! Изменения отправлены на проверку. После проверки менеджером обновлённая информация
                появится на сайте.
            </div>

            <div class="promo__markers">
                <div class="promo__marker promo__marker_green">
                    Бесплатно
                </div>
            </div>

            <div class="promo__data">
                <div class="promo__text">
                    <p>
                        Заполните контактные данные вашей клиники, чтобы включить запись на&nbsp;прием и&nbsp;получать пациентов
                        с&nbsp;нашего сайта.
                    </p>
                    <ol>
                        <li>Включите запись на прием по телефону</li>
                        <li>Подключите мессенджеры и соцсети</li>
                        <li>Получайте пациентов бесплатно</li>
                    </ol>
                </div>
            </div>

            <ValidationObserver ref="clinicForm">
                <div class="promo__form">

                    <div class="field field-text">
                        <label>
                            Телефон регистратуры
                        </label>
                        <div class="field-text__wrap">
                            <input
                                :disabled="disableFields"
                                v-model-phone="clinic.registryPhone"
                                :class="{'hasError' : registryPhoneError}"
                                v-tooltip="{content: registryPhoneError, template: $errTemplate}"
                            >
                            <div v-if="clinic.registryPhone && !disableFields"
                                 class="field-text__wrap_clear"
                                 @click.prevent="clinic.registryPhone = ''">
                                <img src="/img/clear_12x12.svg" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="field field-text">
                        <label>
                            WhatsApp (номер телефона)
                        </label>
                        <div class="field-text__wrap">
                            <ValidationProvider v-slot="{ errors }" :rules="{clinicAnyOfSix: clinicAnyOfSix, socialWhatsApp: true}">
                                <input
                                    v-model-phone="clinic.socialWhatsApp"
                                    :class="{'hasError': errors[0] || whatsAppPhoneError}"
                                    id="socialWhatsApp"
                                    v-tooltip="{content: whatsAppPhoneError, template: $errTemplate }"
                                >
                            </ValidationProvider>
                            <div v-if="clinic.socialWhatsApp"
                                 class="field-text__wrap_clear"
                                 @click.prevent="clinic.socialWhatsApp = ''">
                                <img src="/img/clear_12x12.svg" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="field field-text">
                        <label>
                            Официальный сайт клиники
                        </label>
                        <div class="field-text__wrap">
                            <vee-input
                                placeholder="site.ru"
                                :disabled="disableFields"
                                v-model="clinic.website"
                                vid="website"
                                :rules="{clinicAnyOfSix: clinicAnyOfSix}"
                                :v-beautify="'striptags trim'"
                            />
                            <div v-if="clinic.website && !disableFields"
                                 class="field-text__wrap_clear"
                                 @click.prevent="clinic.website = ''">
                                <img src="/img/clear_12x12.svg" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="field field-text">
                        <label>
                            Telegram (id)
                        </label>
                        <div class="field-text__wrap">
                            <vee-input placeholder="@name"
                                       v-model="clinic.socialTg"
                                       vid="socialTg"
                                       :rules="{clinicAnyOfSix: clinicAnyOfSix}"
                                       :v-beautify="'striptags trim nohttp'"
                            />
                            <div v-if="clinic.socialTg"
                                 class="field-text__wrap_clear"
                                 @click.prevent="clinic.socialTg = ''">
                                <img src="/img/clear_12x12.svg" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="field field-text">
                        <label>
                            Страница Вконтакте
                        </label>
                        <div class="field-text__wrap">
                            <vee-input placeholder="vk.com/clinic"
                                       v-model="clinic.socialVk"
                                       vid="socialVk"
                                       :rules="{clinicAnyOfSix: clinicAnyOfSix, socialVk: true}"
                                       :v-beautify="'striptags trim nohttp vk'"
                            />
                            <div v-if="clinic.socialVk"
                                 class="field-text__wrap_clear"
                                 @click.prevent="clinic.socialVk = ''">
                                <img src="/img/clear_12x12.svg" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="field field-text">
                        <label>
                            Страница Одноклассники
                        </label>
                        <div class="field-text__wrap">
                            <vee-input placeholder="ok.ru/clinic"
                                       v-model="clinic.socialOk"
                                       vid="socialOk"
                                       :rules="{clinicAnyOfSix: clinicAnyOfSix, socialOk: true}"
                                       :v-beautify="'striptags trim nohttp ok'"
                            />
                            <div v-if="clinic.socialOk"
                                 class="field-text__wrap_clear"
                                 @click.prevent="clinic.socialOk = ''">
                                <img src="/img/clear_12x12.svg" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="field field-text">
                        <label>
                            Канал YouTube
                        </label>
                        <div class="field-text__wrap">
                            <vee-input placeholder="youtube.com/clinic"
                                       v-model="clinic.socialYoutube"
                                       vid="socialYoutube"
                                       :rules="{clinicAnyOfSix: clinicAnyOfSix, socialYoutube: true}"
                                       :v-beautify="'striptags trim nohttp youtube'"
                            />
                            <div v-if="clinic.socialYoutube"
                                 class="field-text__wrap_clear"
                                 @click.prevent="clinic.socialYoutube = ''">
                                <img src="/img/clear_12x12.svg" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="field field-text">
                        <label>
                            Email для уведомлений
                        </label>
                        <div class="field-text__wrap">
                            <vee-input placeholder="info@site.ru"
                                       name="Email"
                                       v-model="clinic.email"
                                       rules="email"/>
                            <div v-if="clinic.email"
                                 class="field-text__wrap_clear"
                                 @click.prevent="clinic.email = ''">
                                <img src="/img/clear_12x12.svg" alt="">
                            </div>
                        </div>
                    </div>

                    <div v-if="!(isSupport && clinic.moderationNeeded)" class="promo__actions">
                        <v-loading-component @click="onUpdate">
                            <template slot-scope="{ loadingClass }">
                                <a :class="[{green: needSave, 'btn-disabled': !needSave}, 'promo__btn', loadingClass]">
                                    Сохранить
                                </a>
                            </template>
                        </v-loading-component>
                    </div>
                </div>
            </ValidationObserver>
        </div>
  </main>
</template>

<script>

export default {
  props: {
    isSupport: {
      type: Boolean,
      required: true
    },
  },
  data: function () {
    return {
      clinic: {
        id: '',
        hasLKSubscription: false,
        moderationNeeded: false,
        registryPhone: '',
        email: '',
        website: '',
        socialVk: '',
        socialFb: '',
        socialInsta: '',
        socialOk: '',
        socialYoutube: '',
        socialTg: '',
        socialWhatsApp: '',
        proprietary: ''
      },
      whatsAppPhoneError: null,
      registryPhoneError: null,
      Mhashcode: null,
    };
  },
  created: function () {
    this.getClinicData();
  },
  methods: {
    getClinicData: function () {
      return this.axios.get('booking/data').then(response => {
        this.clinic = response.data;
        setTimeout(() => {
          this.Mhashcode = JSON.stringify(this.clinic).hashCode();
        }, 500)
      });
    },
    onUpdate(btn) {
      this.$refs.clinicForm.validate().then(success => {
        if (!success || this.whatsAppPhoneError || this.registryPhoneError) {
          const el = document.querySelector(".hasError:first-of-type");
          el.scrollIntoView({behavior: "smooth"});
          return;
        }
        if (this.needSave) {
          btn.startLoadingAnimation();
          this.update().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
        }
      });
    },
    update: function (e) {
      return this.axios.post('booking/' + this.clinic.id, this.clinic).then(() => {
        this.getClinicData().then(() => {
          if (this.clinic.moderationNeeded) {
            this.$modal('Данные отправлены на проверку', {
              name: 'ОК',
              callback: () => {
              }
            }, {}, false)
          }
        });
      });
    },
  },
  computed: {
    needSave: function () {
      return this.Mhashcode !== null && (this.Mhashcode !== JSON.stringify(this.clinic).hashCode());
    },
    clinicAnyOfSix() {
      return ['@website', '@socialVk', '@socialOk', '@socialYoutube', '@socialTg', this.clinic.socialWhatsApp, this.clinic.proprietary];
    },
    disableFields() {
      return !this.clinic.hasLKSubscription && this.clinic.proprietary === 'private' && !this.isSupport;
    },
  },
  watch: {
    needSave(val) {
      if (val) {
        window.addEventListener("beforeunload", this.$root.beforeunloadEvent);
      } else {
        window.removeEventListener("beforeunload", this.$root.beforeunloadEvent);
      }
    },
    'clinic.socialWhatsApp'(val) {
      this.whatsAppPhoneError = null;

      const phoneRegex = new RegExp(/(\+?\d[- .\(\)]*){11}/im);
      if (!val.trim() || val.match(phoneRegex)) {
        return;
      }

      this.whatsAppPhoneError = 'Некорректный номер телефона';
    },
    'clinic.registryPhone'(val) {
      this.registryPhoneError = null;

      const phoneRegex = new RegExp(/(\+?\d[- .\(\)]*){11}/im);
      if (val.trim() && val.match(phoneRegex)) {
        return;
      }

      this.registryPhoneError = 'Некорректный номер телефона';
    },
  }
}
</script>
